import { render } from "./MultipleImgSlider.vue?vue&type=template&id=1c7af255&scoped=true"
import script from "./MultipleImgSlider.vue?vue&type=script&lang=js"
export * from "./MultipleImgSlider.vue?vue&type=script&lang=js"

import "./MultipleImgSlider.vue?vue&type=style&index=0&id=1c7af255&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7af255"]])

export default __exports__